<script setup lang="ts">
import {Popover as APopover} from "ant-design-vue";
import {
  Menu as AMenu,
  MenuItem as AMenuItem,
  Spin as ASpin
} from 'ant-design-vue'

import { useXmIndustryDropdownStore } from '../stores/xm-industry-dropdown';

const XmIndustryDropdownStore = useXmIndustryDropdownStore()

const {
  industryList,
  menuProps,
  dropdownProps,
  loading
} = storeToRefs(XmIndustryDropdownStore)

const {
  onSelect
} = XmIndustryDropdownStore;


</script>

<template>
  <ASpin :spinning="loading">
    <a-popover  overlayClassName="xm-industry-dropdown"
                v-if="industryList&&industryList.length>0" placement="left">
      <template #content>
        <div class="xm-industry-dropdown-body" style="min-width:120px">
            <AMenu v-bind="menuProps" @select="onSelect">
              <AMenuItem v-for="item of industryList"
                         :class="item.active?'activeItem':'notActiveItem'"
                         :key="item.tenantId" :title="item.title">
                <a href="javascript:;">{{ item.name||item.label }}</a>
              </AMenuItem>
            </AMenu>
        </div>
      </template>
      <slot></slot>
    </a-popover>

  </ASpin>
</template>
<style type="text/css" lang="less">
.xm-industry-dropdown-body{
  .ant-menu-vertical > .ant-menu-item{
    height: 33px;
    line-height: 33px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
.xm-industry-dropdown{
  .ant-popover-inner-content{
    padding: 4px 4px;
  }
  .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left{
    border-right: 0;
  }
}

</style>
